import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b872b92&scoped=true&"
import script from "./scripts.ts?vue&type=script&lang=ts&"
export * from "./scripts.ts?vue&type=script&lang=ts&"
import style0 from "./styles.scss?vue&type=style&index=0&id=3b872b92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b872b92",
  null
  
)

export default component.exports